<template>
  <div>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
        v-if="loadingExport"
      ></v-progress-circular>
    </v-row>
    <v-row>
      <v-col cols="12">
        <columns-selection
          v-if="!loadingExport"
          :columns="columns"
          :selectedColumns="selectedColumns"
          @changeSelectedColumns="$emit('changeSelectedColumns', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <line-filtering
          v-if="!loadingExport"
          :filterConditions="localFilterConditions"
          @changeFilterConditions="onChangeFilterConditions"
          :columns="columns"
          :selectedColumns="selectedColumns"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'FilterTab',
  emits: ['changeSelectedColumns'],
  components: {
    ColumnsSelection: () => import('@/components/hmd/Exports/ColumnsSelection'),
    LineFiltering: () => import('@/components/hmd/Exports/LineFiltering'),
  },
  data() {
    return {
      localFilterConditions: this.filterConditions,
    }
  },
  props: {
    loadingExport: {
      type: Boolean,
      default: true,
    },
    filterConditions: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    selectedColumns: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    filterConditions: {
      deep: true,
      handler(value) {
        this.localFilterConditions = value
      },
    },
  },
  methods: {
    onChangeFilterConditions(...rest) {
      this.$emit('changeFilterConditions', ...rest)
    },
  },
}
</script>
